// import {Product} from '@local/types/storefront-api-types'
// import {SanityProduct, SanityVariant} from '@local/types'

export const mergeSanityShopifyData = (sanityProduct, shopifyProduct) => {
	const product = {
		...sanityProduct,
		store: {
			...(sanityProduct?.store || {}),
			...shopifyProduct,
		},
	}

	const variants = sanityProduct?.store?.variants?.map(variant => {
		const matchShopifyVariant = shopifyProduct?.variants?.nodes?.find(item => item.id === variant.store.gid)
		if (matchShopifyVariant) {
			return {
				...variant,
				store: {
					...variant.store,
					...matchShopifyVariant,
				},
			}
		}

		return variant
	})

	return {product, variants}
}

/**
 * Extract ID from Shopify GID string (all values after the last slash)
 * e.g. gid://shopify/Product/12345 => 12345
 */
export const extractIdFromGid = (gid: string) => {
	return gid?.match(/[^/]+$/i)?.[0]
}

export const addressIdParsed = (id: string|undefined) => id?.split('?')?.[0]
